import type { DataMode } from './types';
import { getAppModeSync } from '@/lib/appMode';

/**
 * Resolve effective data mode based on app mode.
 * - Demo mode: Always "local" (no sync, uses separate IndexedDB)
 * - Real mode: Always "synced" (production database with sync)
 */
export function resolveEffectiveDataMode(): DataMode {
  const appMode = getAppModeSync();
  return appMode === 'demo' ? 'local' : 'synced';
}

export function isLocalMode(): boolean {
  return resolveEffectiveDataMode() === 'local';
}
